import React from 'react';

import BaseSearchFilterButton from 'components/shared/BaseSearchFilter/BaseSearchFilterButton';
import BaseSearchFilterForm from 'components/shared/BaseSearchFilter/BaseSearchFilterForm';

import { useMediaFilter } from './functions';

const MediaFilterButton = ({
  filter,
  filterName,
  filterKeyName,
  className,
  isRoundButton = false,
  isMobile = false,
  onCloseModal,
  numberOfFilters,
  buttonName,
  type,
}) => {
  const { defaultFilter, handleSave, title, restoredFilter, handleDelete } = useMediaFilter({
    filter,
    filterName,
    filterKeyName,
    onCloseModal,
  });

  return (
    <BaseSearchFilterButton
      isActive={!!filter}
      onDelete={handleDelete}
      className={className}
      isRoundButton={isRoundButton}
      numberOfFilters={numberOfFilters}
      buttonName={buttonName}
      showText={!isMobile}
      showDeleteButton={!isMobile}
      renderFilterForm={({ onClose }) => (
        <BaseSearchFilterForm
          onDelete={isMobile && handleDelete}
          defaultFilter={defaultFilter}
          filter={restoredFilter}
          onClose={onClose}
          onSave={handleSave}
          title={title}
          type={type}
          showRadioButtons
        />
      )}
    />
  );
};

export default MediaFilterButton;
